module.exports = __webpack_public_path__ + "static/media/playlist_yoga.cd677b66.svg";